export default __webpack_public_path__ + "static/media/bg-masthead-1-800w.06b2defe.webp";